import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSearchLoadingStore = defineStore('searchLoading', () => {
  const isLoading = ref(false);

  return {
    isLoading,
  };
});
